import platform from 'platform';
class Platform{
    get isChromeOS(){
        // return true;
        return platform.os.family.indexOf('Chrome OS')  > -1;
    }
    getPlatform(){
        return platform.os.family;
    }
}
export default new Platform();